import { useCallback, useState } from 'react';
import { useActivateCard as useActivateCardMutation } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';
import * as Sentry from '@sentry/react';

/* Hook */
export const useActivateCard = () => {
  const id = useAuthStore((store) => store.id);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  /* Mutations */
  const activateCard = useActivateCardMutation({
    onError: (error: any) => {
      console.log(`Activate card: Unexpected error - ${error.message}`);
      setError(error?.response?.data?.msg);
    },
    onSuccess: () => {
      console.log('Activate card: Successfully activated');
    },
  });

  /* Callbacks */
  const handleActivateCard = useCallback(
    async (
      cardNo: string,
      pin: string,
      activeCode: string,
      noPinPaymentAmount?: string,
    ) => {
      if (!cardNo || !id) return;
      setIsLoading(true);
      setError(undefined);
      try {
        const result = await activateCard.mutateAsync({
          userId: id,
          cardNo,
          pin,
          activeCode,
          ...(noPinPaymentAmount !== undefined && { noPinPaymentAmount }),
        });
        return result;
      } catch (error: any) {
        const errorMessage = error?.response?.data?.msg;
        console.error('Failed to activate card:', errorMessage);
        setError(errorMessage);
        Sentry.captureException({
          message: 'Failed to activate card',
          extra: { error },
        });
        throw new Error(`Failed to activate card: ${errorMessage}`);
      } finally {
        setIsLoading(false);
      }
    },
    [id, activateCard],
  );

  /* Return */
  return {
    handleActivateCard,
    isLoading,
    error,
  };
};
